/* global axios */

import ApiClient from './ApiClient';

class DisparoConfigAPI extends ApiClient {
  constructor() {
    super('disparo_config', { accountScoped: true });
  }

  show() {
    return axios.get(this.url);
  }

  save(payload) {
    return axios.post(this.url, { disparo_config: payload });
  }

  getPermissions() {
    return axios.get(`${this.url}/permissions`);
  }

  updatePermissions(userIds) {
    return axios.post(`${this.url}/update_permissions`, { user_ids: userIds });
  }

  canAccess() {
    return axios.get(`${this.url}/can_access`);
  }
}

export default new DisparoConfigAPI();
